export default "__VITE_PUBLIC_ASSET__1946a302__"